import LeadVettingContainer from './containers/LeadVettingContainer';

export default LeadVettingContainer;
